import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { PartnerService } from '../../services/partner.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { EmployeeService } from '../../services/employee.service';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent implements OnInit {
  public isPageEditable: boolean = true;
  statusMessage: string = "Loading data please wait...";
  productForm: FormGroup;
  IsFormEdit: boolean = false;
  public isSlide: boolean = false;
  sideBarToggle : any;
  memberValue = 'M';
  programType = 'Anyone';
  agegroup = '40';
  planYears = '1';
  creditapply = 'Individual';
  programfor = 'Individual';
  subscriptionCount = 0;
  showSubscription = false;
  subscriptionList: any = [];
  showPartners : boolean = false;
  ageRestriction : boolean = true;
  members = ['0',
    'M',
    'M+1',
    'M+2',
    'M+3',
    '2 Adult + U kids'
  ];

  partnerTypeList = [
    "Corporate",
    "Subscription"
  ]
  creditApplyIndividual = [
    "Individual",
    "N/A"
  ]
  creditApplyOriginal = [
    "Individual",
    "N/A"
  ]
  creditApplyFamily = [
    "Family",
    "N/A"
  ]

  MembersDefaultList = [
    { key : 'M' , value:  'M' }
  ]

  ageGroup1 = [
    { key : '30' , value : 30},
    { key : '40',  value : 40},
    { key : '50', value : 50},
    { key : 'N/A', value : 'N/A'}
  ]
  ageGroup2 = [
    { key : '40',  value : 40},
    { key : '50', value : 50},
    { key : 'N/A', value : 'N/A'}
  ]
  ageGroupTemp = [
    { key : '40',  value : 40},
    { key : '50', value : 50},
    { key : 'N/A', value : 'N/A'}
  ]
  partnerType = '';
  partners = [];
  partnerName = '';
  allPartnersList = [];
  selectedPartnerId : any = null;
  constructor(private _partnerService: PartnerService,private route: ActivatedRoute, private _employeeService: EmployeeService, private router: Router, private fb: FormBuilder) {
    this.productForm = fb.group({
      // planYears: ['', [Validators.required]],
      PlanCost: ['', [Validators.required]],
      Credit: ['', [Validators.required]],
      Consultationcount: [],
      subscriptionName: [],
      agelimit1: [],
      agelimit2: []
    })
    this.getPartnerList();
  }

  ngOnInit() {
    let pageValue = this.route.snapshot.paramMap.get('viewSubscription');
    if(pageValue == 'true'){
      this.viewSubscription();
    }
    console.log('pageValue ',  pageValue);
    this.programfor = 'Individual';
    this.getSubscriptionCount();

  }

  getSubscriptionCount(){
    this._employeeService.getSubscriptionCount().subscribe((data:any) =>{
      if(data.returnCode == 0){
        this.subscriptionCount = data.length + 1;
      }
    })
  }

  selectInitalAge(age:any){
    let filteredAges = [];
    this.ageGroup2 = this.ageGroupTemp;
    for(let index = 0; index < this.ageGroup2.length; index++){
      if(age < this.ageGroup2[index].value){
        filteredAges.push(this.ageGroup2[index]);
      }
    }
    this.ageGroup2 = filteredAges;

  }

  selectLastAge(age : any){
    console.log('age limit ', age);
  }


  AddPartnerProduct(record) {
    let agedata = 0;
    console.log('record ', record);
    console.log('addPartnerProduct ', record.controls.subscriptionName.value);
    console.log('addPartnerProduct ', this.memberValue);
    console.log('addPartnerProduct ', record.controls.Credit.value);
    console.log('addPartnerProduct ', record.controls.Consultationcount.value);
    console.log('addPartnerProduct ', record.controls.PlanCost.value);
    console.log('addPartnerProduct ', this.programType);
    console.log('addPartnerProduct ', this.planYears);
    if((record.controls.subscriptionName.value != '') && (record.controls.Credit.value != '') && (record.controls.Consultationcount.value != '') && (record.controls.PlanCost.value != '') && (this.programType != '')){
      if(record.controls.agelimit1.value == 'N/A'){
        agedata =  null ;
      }
      else if(!record.controls.agelimit1.value){
        agedata =  null ;
      }
      else{
        agedata =  parseInt(record.controls.agelimit1.value);
      }
     
       let subscriptionData = {
        "token": '',
        // "subscriptionid": this.subscriptionCount,
        "subscriptionid": '',
         "subname": record.controls.subscriptionName.value,
         "programfor":this.programfor,
         "credit": record.controls.Credit.value,
         "plancost":record.controls.PlanCost.value,
         "creditapply":this.creditapply,
         "consultationcount":parseInt(record.controls.Consultationcount.value),
         "agerestriction":agedata,
         "programtype":this.programType,
         "members":this.memberValue,
         "planyears":parseInt(this.planYears),
         "partnerid":this.selectedPartnerId
          }
       console.log('subscriptionData save', subscriptionData);
       this._employeeService.insertSubscriptionDetails(subscriptionData).subscribe((data)=>{
         console.log('success data ', data);
         if(data.returnCode == 0){
           alert('Subscription Saved Succcessfully');
           this.productForm.reset();
         }
       })
    }
    else{
      alert('Please Fill all the Subscription Details.');
    }

  }


  reloadCurrentRoute() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
        this.router.navigate([currentUrl]);
    });
}

  

  reset() {
    this.productForm.reset();
    this.IsFormEdit = false;
    this.memberValue = '1';
    this.programType = 'Anyone';
    this.agegroup = '40';
    this.planYears = '1';
    this.creditapply = 'Individual';
    this.programfor = 'Individual';
  }

  selectMembers(id:any){
    this.memberValue = id;
  }

  selectProgramType(id:any){
    console.log('id ', id);
    if(id == 'Corporate'){
      this.programType = id;
      this.showPartners = true;
    }
    else if(id == 'Anyone'){
      this.programType = id;
      this.showPartners = false;
      this.selectedPartnerId = null;
    }
  }
 
  selectAge(age:any){
    this.agegroup = age;
  }
 
  selectCredit(creditapply: any){
    console.log('creditapply ', creditapply);
    this.creditapply = creditapply;
  }
 
  selectPlanYears(planYears: any){
    console.log('planYears ', planYears);
    this.planYears = planYears;
    //this.productForm.controls['planYears'].setValue(this.planYears);
  }
 
  selectPrimary(data: any){
    console.log('data ', data);
    if(data == "family"){
      this.ageRestriction = false;
      this.programfor = data;
      this.creditApplyOriginal = this.creditApplyFamily;
      this.MembersDefaultList = [];
      this.MembersDefaultList = [
        // { key : '0' , value:  '0' },
        { key : 'M' , value:  'M' },
        { key : 'M+1' , value : 'M+1'},
        { key : 'M+2' , value :  'M+2'},
        { key : 'M+3' , value : 'M+3'},
        { key : '(2 Adults + U Kids)' , value : '2 Adults + U Kids'}
      ]

    }
    else if(data == "primary"){
      this.ageRestriction = true;
      this.programfor = data;
      this.creditApplyOriginal = this.creditApplyIndividual;
      this.MembersDefaultList = [];
      this.MembersDefaultList = [
        { key : 'M' , value:  'M' }
      ]
    }
  }
 
  viewSubscription(){
    this.showSubscription = true;
    this.getAllSubscriptionData();
  }

  hideSubscription(){
    this.showSubscription = false;
  }

  getAllSubscriptionData(){
    console.log('getAllSubscription1');
    let data = [];
    this._employeeService.getAllSubscriptionList().subscribe((subscribeData: any)=>{
      this.subscriptionList = subscribeData.response.subscriptionList;
      for(let index = 0 ; index < this.subscriptionList.length ; index++){
        if(this.subscriptionList[index].agerestriction == null){
          this.subscriptionList[index].agerestriction = 'N/A';
        }
        if(this.subscriptionList[index].programtype !== null){
          data.push(this.subscriptionList[index]);
        }
        if(this.subscriptionList[index].agerestriction != 'N/A'){
          this.subscriptionList[index].agelimit2 = parseInt(this.subscriptionList[index].agerestriction) + 10;
        }
        if(!this.subscriptionList[index].isvisible){
          this.subscriptionList[index].isvisible = false
        }
       
      }
      this.subscriptionList = data;
    })
  }

  //method for deleting the subscription.
  deleteSubscription(id){
    let confimationMessage = "Are you sure want to delete the Subscription";
    if (confirm(confimationMessage)) {
    this._employeeService.deleteSubscription(id).subscribe((data)=>{
      if(data.returnCode == 0){
        alert('Subscription Deleted Successfully');
        this.getAllSubscriptionData();
      }
      else{
        alert('Something went Wrong');
      }
    })
  }
  else{
    console.log('else block');
  }
  }


  // method for edit the subscription.
  editSubscription(data){
    console.log('data ', data);
    let subscriptionData = {
       "subscriptionid": data.subscriptionid,
       "subname": data.subname,
       "programfor":data.programfor,
       "credit": data.credit,
       "plancost":data.plancost,
       "creditapply":data.creditapply,
       "consultationcount":parseInt(data.consultationcount),
       "agerestriction":data.agerestriction,
       "programtype":data.programtype,
       "members":data.members,
       "planyears":parseInt(data.planyears),
       "partnerid":data.partnerid
        }
      this.router.navigate(['/editSubscription', subscriptionData]);
    // this.router.navigate(['/editSubscription', {id: patient.Id, name: patient.patientName, email: patient.email, mobile: patient.mobile, appointmentPage : "0"}]);
  
  }

  getPartnerList() {
    let tempPartnersList = [];
    this._partnerService.getPartners()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            this.partners = employeeData.response.partnerList;
            this.allPartnersList = this.partners;
            console.log('this.partners ', this.partners);
            console.log('this.allPartnersList ', this.allPartnersList);
            for(let index = 0; index< this.partners.length;index++){
              if(this.partners[index].partnerType.toLowerCase() == 'Subscription'.toLowerCase()){
                tempPartnersList.push(this.partners[index]);
              }
            }
            this.partners = tempPartnersList;
          }
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }

      );
  }


  selectPartner(data: any){
    let tempPartnersList = [];
    for(let index = 0;index < this.allPartnersList.length;index++){
      if(this.allPartnersList[index].partnerType.toLowerCase() == data.toLowerCase()){
        tempPartnersList.push(this.allPartnersList[index]);
      }
    }
    this.partners = tempPartnersList;
  }

  selectPartnerId(data: any){
    console.log('data ', data);
    this.selectedPartnerId = data;

  }

  openSubscriptionProduct(){
    this.router.navigate(['/SubscriptionProduct']);
  }

  updateCurrentList(subscriptionid: any, status: any){
    for(let index = 0 ; index < this.subscriptionList.length ; index++){
     if(this.subscriptionList[index].subscriptionid == subscriptionid){
      this.subscriptionList[index].isvisible = status;
     }
    }
  }

  activateSubscription(data){
    console.log('data ', data);
    let id = data.subscriptionid;
    let status = true;
    let statusMessage = 'Subscription Plan Activated Succcessfully';
    if(data.isvisible){
      status = false;
      statusMessage = 'Subscription Plan deactivated Successfully';
    }
    this._employeeService.activateSubscriptionPlan(id, status).subscribe((data)=>{
      console.log('success data ', data);
      if(data.returnCode == 0){
        this.updateCurrentList(id, status);
        alert(statusMessage);
        this.productForm.reset();
      }
    })

  }

}



// WEBPACK FOOTER //
// ./src/app/admin/subscription/subscription.component.ts